
import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * Breadcrumbs Component
 * Figma tasarımına uygun breadcrumb navigasyon component'i
 */
@Component
export default class Breadcrumbs extends Vue {
  @Prop({ type: Array, required: true })
  items!: string[];

  @Prop({ type: Boolean, default: true })
  showHomeIcon!: boolean;

  /**
   * Breadcrumb item için class belirleme
   * Son item aktif (koyu renk), diğerleri pasif (açık gri)
   */
  getBreadcrumbClass(index: number): string {
    const isLast = index === this.items.length - 1;
    return isLast
      ? 'breadcrumb-item breadcrumb-item--active'
      : 'breadcrumb-item breadcrumb-item--inactive';
  }
}
